"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("../ExtendableError"));
/**
 * Thrown when attempting to use an invalid operator in a Dynamo filter
 * expression
 * @param {string} operator
 */
class InvalidOperatorError extends ExtendableError_1.default {
    constructor(operator) {
        super(`Invalid filter operator: ${operator}`);
        this.operator = operator;
        this.operator = operator;
    }
}
exports.default = InvalidOperatorError;
